import { HomePage } from './../home/home';
import { Component, OnInit } from '@angular/core';
import { NavController, NavParams, AlertController, ToastController, Events } from 'ionic-angular';
import { FormGroup, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { LoadingProvider } from '../../providers/loading/loading';
import { AngularFireAuth } from 'angularfire2/auth';
import firebase from 'firebase/app';
import { AngularFirestore } from 'angularfire2/firestore';
import { Storage } from '@ionic/storage';
import { MaintenacePage } from '../maintenace/maintenace';

// @IonicPage({
//   name: 'LoginPage',
//   segment: 'login'
// })

@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage implements OnInit{

  userData:any;
	loginData = { user_email:'', user_password:'' };
	authForm : FormGroup;
	user_email: AbstractControl;
	user_password: AbstractControl;
  passwordtype:string='password';
  passeye:string ='eye';
  getRole:any;
  rootPage:any;

  constructor(
    public navCtrl: NavController,
    public fb: FormBuilder,
    public navParams: NavParams,
    public alertCtrl: AlertController,
    public toastCtrl: ToastController,
    public afAuth: AngularFireAuth,
    public loadingProvider: LoadingProvider,
    public afs: AngularFirestore,
    public db: AngularFirestore,
    public storage: Storage,
    public events: Events
    ) {
      this.authForm = this.fb.group({
        'user_email' : [null, Validators.compose([Validators.required])],
        'user_password': [null, Validators.compose([Validators.required])],
      });

      this.user_email = this.authForm.controls['user_email'];
      this.user_password = this.authForm.controls['user_password'];

  }

  // For User Login
  public userLogin(loginData){
    debugger;
    this.loadingProvider.startLoading();
    firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION)
    .then(function() {
      firebase.auth().signInWithEmailAndPassword(loginData.user_email, loginData.user_password)
        .then(result => {
          console.log('result',result)
          window.localStorage.setItem("uid", result.user.uid);
          window.localStorage.setItem("email", result.user.email);
          this.loadingProvider.stopLoading();
          let thiss = this;
          var docRef = firebase.firestore().collection("users").doc(result.user.uid);
          docRef.get().then(function(doc) {
            console.log('doc',doc.data());
              if (doc.exists) {
                let user_data = doc.data();
                console.log(user_data);
                if(user_data.deleted == 1){
                  thiss.presentToastError('This contact deleted.');
                  return false;
                }else if(user_data.roles.super_admin){
                  thiss.getRole = 'super_admin';
                }else if(user_data.roles.broker){
                  thiss.getRole = 'broker';
                }else if(user_data.roles.loan_admin){
                  thiss.getRole = 'loan_admin';
                }else{
                  thiss.getRole = 'contact';
                }
                window.localStorage.setItem("userRole", thiss.getRole);
                window.localStorage.setItem("brokerFirstname", user_data.firstname);
                window.localStorage.setItem("brokerLastname", user_data.lastname);
                thiss.loginUser(thiss.getRole);

                if(thiss.getRole == "super_admin" || thiss.getRole == "loan_admin"){
                  // thiss.navCtrl.setRoot(HomePage);
                  thiss.navCtrl.setRoot('AdminDashboardPage');
                }
                else if(thiss.getRole == "broker") {
                  window.localStorage.setItem("contact_uid", user_data.uid);

                  //  thiss.navCtrl.setRoot('BrokerDashboardPage');
                  thiss.navCtrl.setRoot('AdminDashboardPage');
                }
                else if(thiss.getRole == "contact"){
                  debugger;
                  //thiss.navCtrl.setRoot(ViewContactPage);
                  window.localStorage.setItem("contact_uid", user_data.uid);

                  thiss.navCtrl.setRoot('CustomerDashboardPage',{
                    contact_uid:user_data.uid,
                    });
                  // thiss.navCtrl.setRoot(ShowContactForm,{
                  //   contact_uid:user_data.uid,
                  //   });
                  // thiss.getUsersData(result.user.uid).subscribe((getUsersData)=>{
                  //   if(getUsersData.length > 0){
                  //     window.localStorage.setItem("SDF_form_document_id", getUsersData[0].SDF_form_document_id);
                  //     if(user_data.accessPermission == 1){
                  //       thiss.navCtrl.setRoot(ViewContactPage);
                  //     }else{
                  //       thiss.navCtrl.setRoot(ViewContactPage);
                  //     }
                  //   }
                  // })
                }else{
                  thiss.navCtrl.setRoot(LoginPage);
                }
              }
            }).catch(function(error) {
              console.log("Error getting document:", error);
              
              // navigate new page 
              thiss.navCtrl.setRoot(MaintenacePage);

          });          
        }).catch(err => {
          this.loadingProvider.stopLoading();
          this.presentToast(err);
        });
      }).catch(persisErr=>{
        
        console.error(persisErr);
        
      });
  }

  getUsersData (uid){
    return this.db.collection<any>( "users_data", ref => ref.where('uid','==',uid ).where('deleted','==',0 )).valueChanges ();
  }

  loginUser(user) {
    this.events.publish('user:signedIn', user, Date.now());
  }

  ngOnInit(){
  }

  //Move to Home Page
  moveToHome(res){
    this.navCtrl.setRoot(HomePage,{res:res});
  }

  presentToast(err) {
    const toast = this.toastCtrl.create({
      message: err.message,
      duration: 3000,
      position: 'bottom'
    });

    toast.present();
  }

  presentToastError(err) {
    const toast = this.toastCtrl.create({
      message: err,
      duration: 3000,
      position: 'bottom'
    });

    toast.present();
  }

  // login and go to home page
  login() {
    this.navCtrl.setRoot(HomePage);
  }

  

  forgotPass() {
    let forgot = this.alertCtrl.create({
      title: 'Forgot Password?',
      message: "Enter you email address to send a reset link password.",
      inputs: [
        {
          name: 'email',
          placeholder: 'Email',
          type: 'email'
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          handler: data => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Send',
          handler: data => {
            let toast = this.toastCtrl.create({
              message: 'Email was sended successfully',
              duration: 3000,
              position: 'top',
              cssClass: 'dark-trans',
              closeButtonText: 'OK',
              showCloseButton: true
            });
            toast.present();
          }
        }
      ]
    });
    forgot.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts